//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    options: {
      default: () => {
        return ["Option 1", "Option 2", "Option 3"];
      },
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      selectedOption: this.options[0],
      showOptions: false,
    };
  },
  watch: {
    options() {
      this.selectedOption = this.options[0];
    },
  },
  methods: {
    selectOption(option) {
      if (!this.disabled) {
        this.selectedOption = option;
        this.$emit("changeOption", this.selectedOption);
        this.showOptions = false;
      }
    },
  },
  mounted() {},
};
